// removed by extract-text-webpack-plugin
module.exports = {"container":"_1i0h9_18OCHs_M11SZ_G_R","content":"_26SerE7-2pfxd5lmAn5pXj"};


//////////////////
// WEBPACK FOOTER
// ./src/client/Layouts/DashboardLayout.css
// module id = 1126
// module chunks = 58